<script>
export default {
  name: 'StarsRateSvg',
  props: {
    width: {
      type: [Number, String],
      default: 142,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    fill: {
      type: String,
      default: '#eec586',
    },
    stroke: {
      type: String,
      default: '#eec586',
    },
    strokeWidth: {
      type: [Number, String],
      default: 1,
    },
  },
};
</script>

<!-- eslint-disable max-len -->
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 142 24"
    :fill="fill"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0369 2.2398C12.2135 1.84587 12.7728 1.84587 12.9494 2.2398L15.175 7.20385C15.3972 7.69935 15.8698 8.03609 16.4106 8.08427L21.9405 8.57691C22.3832 8.61634 22.5582 9.17047 22.2186 9.45707L18.1051 12.9281C17.6736 13.2921 17.4831 13.8676 17.6121 14.4171L18.0989 14.3029L17.6121 14.4171L18.8255 19.5886C18.9253 20.0137 18.4704 20.3534 18.091 20.1371L13.2363 17.3682C12.7757 17.1055 12.2106 17.1055 11.75 17.3682L6.8953 20.1371C6.51598 20.3534 6.06105 20.0137 6.16081 19.5886L7.37424 14.4171C7.5032 13.8676 7.31268 13.2921 6.88125 12.9281L2.76775 9.45707C2.4281 9.17047 2.60318 8.61634 3.04583 8.57691L8.5757 8.08427C9.11657 8.03609 9.58917 7.69935 9.81132 7.20385L9.35508 6.9993L9.81132 7.20385L12.0369 2.2398Z"
      :fill="fill"
      :stroke="stroke"
      :stroke-width="strokeWidth"
    />
    <path
      d="M41.4471 2.2398C41.6237 1.84587 42.1829 1.84587 42.3596 2.2398L44.5852 7.20385C44.8073 7.69935 45.2799 8.03609 45.8208 8.08427L51.3507 8.57691C51.7933 8.61634 51.9684 9.17047 51.6287 9.45707L47.5152 12.9281C47.0838 13.2921 46.8933 13.8676 47.0222 14.4171L47.509 14.3029L47.0222 14.4171L48.2357 19.5886C48.3354 20.0137 47.8805 20.3534 47.5012 20.1371L42.6465 17.3682C42.1859 17.1055 41.6208 17.1055 41.1602 17.3682L36.3055 20.1371C35.9261 20.3534 35.4712 20.0137 35.571 19.5886L36.7844 14.4171C36.9134 13.8676 36.7228 13.2921 36.2914 12.9281L32.1779 9.45707C31.8383 9.17047 32.0133 8.61634 32.456 8.57691L37.9859 8.08427C38.5267 8.03609 38.9993 7.69935 39.2215 7.20385L38.7652 6.9993L39.2215 7.20385L41.4471 2.2398Z"
      :fill="fill"
      :stroke="stroke"
      :stroke-width="strokeWidth"
    />
    <path
      d="M70.8572 2.2398C71.0338 1.84587 71.5931 1.84587 71.7697 2.2398L73.9953 7.20385C74.2175 7.69935 74.6901 8.03609 75.2309 8.08427L80.7608 8.57691C81.2035 8.61634 81.3785 9.17047 81.0389 9.45707L76.9254 12.9281C76.494 13.2921 76.3034 13.8676 76.4324 14.4171L76.9192 14.3029L76.4324 14.4171L77.6458 19.5886C77.7456 20.0137 77.2907 20.3534 76.9113 20.1371L72.0566 17.3682C71.596 17.1055 71.0309 17.1055 70.5703 17.3682L65.7156 20.1371C65.3363 20.3534 64.8814 20.0137 64.9811 19.5886L66.1946 14.4171C66.3235 13.8676 66.133 13.2921 65.7016 12.9281L61.5881 9.45707C61.2484 9.17047 61.4235 8.61634 61.8661 8.57691L67.396 8.08427C67.9369 8.03609 68.4095 7.69935 68.6316 7.20385L68.1754 6.9993L68.6316 7.20385L70.8572 2.2398Z"
      :fill="fill"
      :stroke="stroke"
      :stroke-width="strokeWidth"
    />
    <path
      d="M100.271 2.2398C100.448 1.84587 101.007 1.84587 101.184 2.2398L103.409 7.20385C103.632 7.69935 104.104 8.03609 104.645 8.08427L110.175 8.57691C110.618 8.61634 110.793 9.17047 110.453 9.45707L106.339 12.9281C105.908 13.2921 105.718 13.8676 105.846 14.4171L106.333 14.3029L105.846 14.4171L107.06 19.5886C107.16 20.0137 106.705 20.3534 106.325 20.1371L101.471 17.3682C101.01 17.1055 100.445 17.1055 99.9844 17.3682L95.1297 20.1371C94.7504 20.3534 94.2954 20.0137 94.3952 19.5886L95.6086 14.4171C95.7376 13.8676 95.5471 13.2921 95.1156 12.9281L91.0021 9.45707C90.6625 9.17047 90.8376 8.61634 91.2802 8.57691L96.8101 8.08427C97.3509 8.03609 97.8235 7.69935 98.0457 7.20385L97.5895 6.9993L98.0457 7.20385L100.271 2.2398Z"
      :fill="fill"
      :stroke="stroke"
      :stroke-width="strokeWidth"
    />
    <path
      d="M129.681 2.2398C129.858 1.84587 130.417 1.84587 130.594 2.2398L132.82 7.20385C133.042 7.69935 133.514 8.03609 134.055 8.08427L139.585 8.57691C140.028 8.61634 140.203 9.17047 139.863 9.45707L135.75 12.9281C135.318 13.2921 135.128 13.8676 135.257 14.4171L135.743 14.3029L135.257 14.4171L136.47 19.5886C136.57 20.0137 136.115 20.3534 135.736 20.1371L130.881 17.3682C130.42 17.1055 129.855 17.1055 129.395 17.3682L124.54 20.1371C124.161 20.3534 123.706 20.0137 123.805 19.5886L125.019 14.4171C125.148 13.8676 124.957 13.2921 124.526 12.9281L120.412 9.45707C120.073 9.17047 120.248 8.61634 120.69 8.57691L126.22 8.08427C126.761 8.03609 127.234 7.69935 127.456 7.20385L127 6.9993L127.456 7.20385L129.681 2.2398Z"
      :fill="fill"
      :stroke="stroke"
      :stroke-width="strokeWidth"
    />
  </svg>
</template>
<!-- eslint-enable max-len -->
